/**
 * @file 左侧导航菜单
 * @author liwei.zhu
 */
import React, { Component } from 'react';
import { observable, action, toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Layout, Menu, Icon } from 'antd';
import routerList from 'routers';
import can from 'pages/common/decorators/can';
import styles from './index.less';

const SubMenu = Menu.SubMenu;
const { Sider } = Layout;

@can()
@observer
export default class SiderMenu extends Component {
    @observable defaultOpenKeys = []; // 默认展开菜单
    @observable defaultSelectedKeys = []; // 默认选中菜单
    @observable silderTitle = '分销运营平台';

    static propTypes = {
        history: PropTypes.shape({}).isRequired,
        location: PropTypes.shape({}).isRequired,
        can: PropTypes.func.isRequired,
    };
    @action
    getNavMenuItems(menusData, parentPath = '') {
        // 渲染导航菜单
        if (!menusData) {
            return [];
        }
        const { can, location } = this.props;
        return menusData.map(item => {
            if (!item.name || item.hideInMenu || (item.permission && !can(item.permission))) {
                // 判断是否有权限
                return null;
            }
            let itemPath = item.path;
            if (parentPath && parentPath != '/') {
                itemPath = parentPath + '/' + itemPath;
            }
            if (item.children && item.children.some(child => child.name)) {
                // 判断是否有子菜单
                const showChildrenNum = item.children.reduce(
                    (res, cur) => [...res, ...(cur.hideInMenu ? [] : [cur])],
                    []
                );
                if (showChildrenNum.length > 0) {
                    if (location && location.pathname) {
                        const pathArr = location.pathname.split('/');
                        if (itemPath == '/' + pathArr[1]) {
                            this.defaultOpenKeys.push(item.key || itemPath);
                        }
                    }
                    return (
                        <SubMenu
                            title={
                                item.icon ? (
                                    <span>
                                        <Icon type={item.icon} />
                                        <span>{item.name}</span>
                                    </span>
                                ) : (
                                    item.name
                                )
                            }
                            key={item.key || itemPath}
                        >
                            {this.getNavMenuItems(item.children, itemPath)}
                        </SubMenu>
                    );
                }
            }
            const icon = item.icon && <Icon type={item.icon} />;
            return (
                <Menu.Item key={item.key || itemPath}>
                    <Link to={itemPath} href={itemPath}>
                        {icon}
                        <span>{item.name}</span>
                    </Link>
                </Menu.Item>
            );
        });
    }
    @action
    render() {
        const { location } = this.props;
        if (location && location.pathname) {
            this.defaultSelectedKeys = [location.pathname];
        }
        const navList = this.getNavMenuItems(routerList);
        const defaultSelectedKeys = toJS(this.defaultSelectedKeys);
        const defaultOpenKeys = toJS(this.defaultOpenKeys);

        return (
            <Sider theme="light" className={styles.sider}>
                <div className={styles.logo}>{this.silderTitle}</div>
                <Menu
                    mode="inline"
                    defaultOpenKeys={defaultOpenKeys}
                    selectedKeys={defaultSelectedKeys}
                    className={styles.menu}
                >
                    {navList}
                </Menu>
            </Sider>
        );
    }
}
